import { useEffect, useState } from 'react'

import { PrimaryButton } from '@joor/design-system'
import styled from 'styled-components'

import { atlasClient } from 'graphql/client'

import { useSaveProductImages } from '../../manageImagesModal.hooks'
import { ModalIds } from '../../manageImagesModal.ids'
import messages from '../../manageImagesModal.messages'
import { checkIfProductImagesHasChanges } from '../../manageImagesModals.utils'
import useStore from '../../store/useManageImagesStore'
import StyleNavigation from './components/StyleNavigation'

const ActionsContainer = styled.div`
  display: flex;
  justify-content: end;
`

const SaveButton = styled(PrimaryButton)`
  width: auto;
`

const Actions = (): JSX.Element => {
  const isRemovingImages = useStore((state) => state.isRemovingImages)
  const isSavingImages = useStore((state) => state.isSavingImages)
  const productImages = useStore((state) => state.productImages)
  const productImagesBak = useStore((state) => state.productImagesBak)
  const setIsSavingImages = useStore((state) => state.setIsSavingImages)
  const hasStyleColorChanges = useStore((state) => state.hasStyleColorChanges)
  const isUploadingImages = useStore((state) => state.isUploadingImages)
  const isStyleDataLoading = useStore((state) => state.isStyleDataLoading)
  const setIsStyleDataLoading = useStore((state) => state.setIsStyleDataLoading)
  const softResetStore = useStore((state) => state.softResetStore)
  const [hasProductImagesChanges, setHasProductImagesChanges] = useState(false)
  const { saveProductImages } = useSaveProductImages()

  useEffect(() => {
    setHasProductImagesChanges(
      checkIfProductImagesHasChanges(productImagesBak, productImages),
    )
  }, [productImages, productImagesBak])

  const isDisabled =
    isStyleDataLoading ||
    isRemovingImages ||
    isSavingImages ||
    isUploadingImages ||
    (!hasStyleColorChanges && !hasProductImagesChanges)

  const handleSave = async () => {
    if (isDisabled) return
    setIsSavingImages({ isSavingImages: true })
    const { error } = await saveProductImages()
    if (!error) {
      softResetStore()
      atlasClient.cache.evict({ fieldName: 'listUnmatchedUploads' })
      setIsStyleDataLoading({ isStyleDataLoading: true })
      atlasClient.cache.evict({ fieldName: 'getManageImagesStyleData' })
    }
    setIsSavingImages({ isSavingImages: false })
  }

  return (
    <ActionsContainer>
      <StyleNavigation disabled={isDisabled} />
      <SaveButton
        id={ModalIds.SaveButton}
        data-testid={ModalIds.SaveButton}
        disabled={isDisabled}
        loading={isSavingImages}
        onClick={handleSave}
      >
        {messages.save}
      </SaveButton>
    </ActionsContainer>
  )
}

export default Actions
